<template>
  <div class="tb-list-item">
    <div class="tb-list-item-meta">
      <div class="tb-list-item-meta-icon">
      </div>
      <div class="tb-list-item-meta-content">
        <h4 class="tb-list-item-meta-title">
          <span title="imei" class="imei">IMEI</span>
          <span :class="{'link':data.type == 1 || data.type == 2}" @click="clickImei">{{data.imei}}</span>
        </h4>
        <div class="tb-list-item-meta-description">
          <span>
            <Icon :custom="onlineStatusIcon" />
            <span>{{data.onlineStatusDisplay}}</span>
          </span>
          <span :title="'电量'+data.carBatteryDisplay">
            <Icon :custom="batteryIcon" />
            <span>{{data.carBatteryDisplay}}</span>
          </span>
          <span :title="'行驶里程：'+totalMileage" v-if="this.data.totalMileage">
            <Icon type="md-flag"/>
            <span>{{totalMileage}}</span>
          </span>
          <span :title="'行驶时长：'+totalDuration" v-if="this.data.totalDuration">
            <Icon type="ios-time"  />
            <span>{{totalDuration}}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { duration } from '@/util'
export default {
  data() {
    return {

    }
  },
  computed: {

    totalMileage() {
      return this.data.totalMileage ? (this.data.totalMileage.toFixed(2) + 'km') : 'n/a'
    },
    totalDuration() {
      return this.data.totalDuration ? duration(this.data.totalDuration) : 'n/a'
    },
    onlineStatusIcon() {
      return this.data['status.onlineStatus'] == 1 ? 'i-icon icon-online' : 'i-icon icon-offline'
    },
    batteryIcon() {
      let v = this.data['status.carBattery']
      let iconValue = 0
      if (v >= 0 && v <= 100) {
        iconValue = Math.ceil(v / 25)
      }
      return 'i-icon icon-battery' + iconValue
    }
  },
  monuted() {
    console.log(this.$props)
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  methods:{
    clickImei(){
      if(this.data.type){
        this.$emit('imei',this.data.imei)
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.tb-list-item {
  display: flex;
  align-items: center;

  .link{
    color:#2D8cF0;
  }
  // padding: 12px 0;
  .flex {
    align-items: center;
  }

  .imei {
    background: rgba(0, 0, 0, .4);
    border-radius: 4px;
    padding: 0 3px;
    font-size: 8px;
    color: #fff;
    margin-right: 3px;
  }

  .tb-list-item-meta {
    display: flex;
    flex: 1 1 60%;
    align-items: flex-start;
    font-size: 0;
    align-items: center;
  }

  .tb-list-item-meta-icon {
    font-size: 54px;
    line-height: 0;
  }

  .tb-list-item-meta-title {
    margin-bottom: 4px;
    color: rgba(0, 0, 0, .65);
    font-size: 14px;
    line-height: 1em;
    font-weight: 500;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .tb-list-item-meta-description {
    color: rgba(0, 0, 0, .5);
    font-size: 12px;

    i {
      font-size: 12px
    }

    &>span {
      margin-right: 7px;
    }
  }

  .tb-list-item-content {
    display: flex;
    flex: 1 1 40%;
    justify-content: flex-end;
    color: rgba(0, 0, 0, .5);
    font-size: 12px;

    .tb-list-item-content-item {
      text-align: right;

      p {
        margin-top: 4px;
        margin-bottom: 0;
        line-height: 22px;
        font-size: 13px;
      }
    }

  }
}

</style>
